type ContentItem = string | HTMLElement | DocumentFragment;

/**
 * The elt function streamlines calls to DOM APIs for creating new DOM nodes,
 * setting attributes, and adding children.s
 * @param tag - the name of the tag to create, e.g. "div".
 * @param attrs - a mapping of attributes, e.g. {"class": "active"}
 * @param content - one or more nodes that can be a child of the given
 * tag. This can be string, HTMLElement, or DocumentFragment.
 */
export const elt = <T = HTMLElement>(
        tag: string,
        attrs: Record<string, string> = {},
        ...content: ContentItem[]
    ): T =>
{
    var result = document.createElement(tag);
    for(let [name, value] of Object.entries(attrs)) {
        result.setAttribute(name, value);
    }
    for(let item of content) {
        if(typeof(item) == 'string') {
            result.append(document.createTextNode(item));
        } else {
            result.appendChild(item);
        }
    }
    return result as T;
}
export default elt;
